import { IEmail, IEmailVm } from "../../../models/response/email/IEmail";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';

export const eEmailDefine = {
    LOAD_START: undefined,
    LOAD_SUCCCES: [] as IEmailVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IEmail | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IEmail,
    SAVE_SUCCESS: {} as IEmail,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    CHANGE_SELECTED_IDS: [] as number[],
    CHANGE_APPROVE_SELECTED_IDS: [] as number[],
    CHANGE_TRANGTHAI_SELECTED_IDS: [] as number[],
    SHOW_DETAIL_APPROVE_MODAL: {} as boolean | undefined,
    CLOSE_DETAIL_APPROVE_MODAL: {} as boolean | undefined,
    SHOW_APPROVE_MODAL: {} as boolean | undefined,
    CLOSE_APPROVE_MODAL: {} as boolean | undefined,
    APPROVE_START: [] as number[],
    APPROVE_SUCCESS: undefined,
    APPROVE_ERROR: "",
    SHOW_REJECT_MODAL: {} as boolean | undefined,
    CLOSE_REJECT_MODAL: {} as boolean | undefined,
    REJECT_START: [] as number[],
    REJECT_SUCCESS: undefined,
    REJECT_ERROR: "",

}
export const eEmailActionTypeIds = generateActionTypeIds(eEmailDefine, "EMAIL")
export type IEmailActionTypes = IGenericActionType<typeof eEmailDefine, "EMAIL">